<div class="w-full">
  <div class="w-full" *ngFor="let accordionData of accordionData; let index = index"
       [class.accordion-section-separation]="index>0">
    <div class="w-full flex justify-between items-center">
      <div class="accordion-title w-[90%]">
        {{accordionData?.title}}
      </div>
      <div class="w-[10%] flex justify-center items-center">
        <app-icon [svgIcon]="getIcons(accordionData.expanded)" class="accordion-icon cursor-pointer"
                  (click)="onToggleButtonClicked(index)"></app-icon>
      </div>
    </div>
    <div *ngIf="accordionData?.expanded" class="accordion-section font-regular prose" [innerHtml]="accordionData?.content">
    </div>
    <hr class="section-separation w-full">
  </div>
</div>
